/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const copyCampaignDataSchema = z.object({
	title: z.string().nullable().optional(),
})

export type CopyCampaignDataSchema = z.infer<typeof copyCampaignDataSchema>
